import {
  Button,
  BUTTON_COLOR,
  LINK_SIZE,
  linkClasses,
} from "@hireart/component-library";
import PropTypes from "prop-types";

/* A button that looks like a link */
export const LinkButton = ({ children, size = LINK_SIZE.SMALL, ...rest }) => {
  return (
    <Button
      isUnstyled
      className={linkClasses({ size })}
      color={BUTTON_COLOR.TEXT_PURPLE}
      {...rest}
    >
      {children}
    </Button>
  );
};

LinkButton.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
};
